import { type IntlShape } from 'react-intl'

import { type PimVariantAttributeV1 } from '@redteclab/api/clients/bully'

const attributeLabelOverrides = (
  variantAttribute: string,
  i18n: IntlShape,
): string | undefined => {
  return {
    color_number: i18n.formatMessage({
      id: 'variantAttributes.label.color_number',
    }),
    package_size: i18n.formatMessage({
      id: 'variantAttributes.label.package_size',
    }),
  }[variantAttribute]
}

export const variantAttributeAccessorGetLabelText = (
  attribute: PimVariantAttributeV1,
  i18n: IntlShape,
): string | undefined => {
  const { label, variant_attribute: variantAttribute } = attribute

  const overrideLabel = attributeLabelOverrides(variantAttribute, i18n)

  if (overrideLabel) {
    return overrideLabel
  }

  return label
}
